import { c as _c } from "react/compiler-runtime";
import React from "react";
interface DialedDigitsDisplayProps {
  digits: string;
}
const DialedDigitsDisplay: React.FC<DialedDigitsDisplayProps> = t0 => {
  const $ = _c(4);
  const {
    digits
  } = t0;
  if (!digits) {
    return null;
  }
  let t1;
  if ($[0] !== digits) {
    t1 = digits.split("").map(_temp);
    $[0] = digits;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="mt-2"><span className="font-mono text-h3 font-medium text-foreground">{t1}</span></div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default DialedDigitsDisplay;
function _temp(digit, index) {
  return <span key={index} className="inline-block">{digit}</span>;
}